export const validateFormResetPwd = (values) => {
  const errors = {};
  if (!values.password) {
    errors.password = "La contraseña es requerida";
  } else if (values.password.length < 8) {
    errors.password = "La contraseña debe tener al menos 8 caracteres";
  }

  if (!values.newPassword) {
    errors.newPassword = "La contraseña es requerida";
  } else if (values.newPassword.length < 8) {
    errors.newPassword = "La contraseña debe tener al menos 8 caracteres";
  }
  if (values.password !== values.newPassword) {
    errors.notMatch = "Las contraseñas no coinciden";
  }
  return errors;
};

export const validateFormSendEmail = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = "El correo electrónico es requerido";
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = "Correo electrónico inválido";
  }
  return errors;
};
